import { get, post, put, remove, removeMultiple } from "../../utils/httpClient";

const taskTemplateService = () => {
  const prefixApi = "duedates/tasktemplates";

  const getTaskTemplate = async (templateId) => {
    return await get(`/${prefixApi}/${templateId}`);
  };

  const getTaskTemplates = async (taskTypeId) => {
    return await get(`/${prefixApi}/tasktype`, {
      taskTypeId: taskTypeId,
    });
  };

  const getAllTaskTemplates = async () => {
    return await get(`/${prefixApi}`);
  };

  const createTaskTemplate = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateTaskTemplate = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const updateRestoreDefault = async (json) => {
    return await put(`/${prefixApi}/default`, json);
  };

  const deleteTaskTemplate = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  const deleteMultipleTaskTemplates = async (json) => {
    return await removeMultiple(`/${prefixApi}`, json);
  };

  return {
    getTaskTemplate,
    getTaskTemplates,
    createTaskTemplate,
    updateTaskTemplate,
    deleteTaskTemplate,
    deleteMultipleTaskTemplates,
    getAllTaskTemplates,
    updateRestoreDefault,
  };
};

export default taskTemplateService;
